import React from 'react';
import { Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

export default function EventShareDialog({
  open, onClose, url, consumerName, eventName, c,
}: { open: boolean; onClose: () => void; url: string | null; consumerName: string; eventName: string; c: any }) {
  const copy = async () => { if (url) await navigator.clipboard.writeText(url); };
  const share = () => {
    if (!url) return;
    const text = `Hi ${consumerName}, your personalised PSF link for ${eventName} is ready: ${url}`;
    window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, '_blank', 'noopener,noreferrer');
  };
  return <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth PaperProps={{ sx: { bgcolor: c.surfaceCard } }}>
    <DialogTitle sx={{ color: c.text, display: 'flex', justifyContent: 'space-between', fontWeight: 800 }}>
      Share Link Created <IconButton onClick={onClose} sx={{ color: c.textMuted }}><CloseIcon /></IconButton>
    </DialogTitle>
    <DialogContent dividers sx={{ bgcolor: c.surface }}>
      <Typography sx={{ color: c.textMuted, mb: 2 }}>You are sharing: <b style={{ color: c.orange }}>{eventName}</b></Typography>
      <Alert severity="success" sx={{ mb: 2 }}>Share link created successfully!</Alert>
      <Box sx={{ p: 2, bgcolor: '#222', color: '#fff', border: `1px solid ${c.border}`, borderRadius: 1, fontFamily: 'monospace', wordBreak: 'break-all' }}>{url}</Box>
      <Button fullWidth variant="contained" startIcon={<ContentCopyIcon />} onClick={copy} sx={{ mt: 2, bgcolor: c.orange }}>Copy Link</Button>
      <Button fullWidth variant="outlined" startIcon={<WhatsAppIcon />} onClick={share} sx={{ mt: 1.5, color: '#25D366', borderColor: '#25D366' }}>WhatsApp</Button>
    </DialogContent>
    <DialogActions><Button onClick={onClose} variant="contained" sx={{ bgcolor: c.orange }}>Done</Button></DialogActions>
  </Dialog>;
}
